<div class="combo" [ngClass]="classes">
  <ng-container *ngIf="visibleLabel; else arialabelonly">
    <div [id]="labelId" class="combo-label">{{ visibleLabel }}</div>
  </ng-container>
  <ng-template #arialabelonly>
    <div [id]="labelId" class="sr-only">{{ ariaLabel }}</div>
  </ng-template>
  <div
    class="combo-selected-label"
    [id]="comboId"
    [attr.aria-controls]="listboxId"
    [attr.aria-expanded]="open"
    [attr.aria-labelledby]="labelId"
    [attr.aria-activedescendant]="activeIndex >= 0 ? getOptionId(activeIndex) : ''"
    [ngClass]="{ open: open }"
    aria-haspopup="listbox"
    role="combobox"
    tabindex="0"
    (blur)="onComboBlur()"
    (click)="onComboClick()"
    (keydown)="onComboKeyDown($event)"
  >
    <app-icon
      *ngIf="comboboxIcon"
      [icon]="comboboxIcon.icon"
      [size]="comboboxIcon.size"
      [colour]="comboboxIcon.colour"
      [margin]="{ right: comboboxIcon.margin }"
    ></app-icon>
    <ng-content></ng-content>
    <span class="combo-label-text">
      {{
        selectedTextDisplay ??
          selectedOptionLabelTranslated ??
          (selectedOptionLabel ? (selectedOptionLabel | translateString : lang) : null) ??
          placeholder
      }}
    </span>
  </div>
  <div
    [id]="listboxId"
    role="listbox"
    class="combo-menu"
    [attr.aria-labelledby]="labelId"
    tabindex="-1"
    [hidden]="!open"
  >
    <div
      *ngFor="let option of options; index as i"
      class="option"
      [class.isactive]="i === activeIndex"
      [class.isselected]="i === selectedIndex"
      [id]="getOptionId(i)"
      role="option"
      [attr.aria-selected]="i === selectedIndex"
      [attr.disabled]="option.disabled ? 'disabled' : null"
      [value]="option.value"
      (click)="option.disabled ? (open = false) : onOptionClick(i)"
      (mousedown)="option.disabled ? (open = false) : onOptionMouseDown($event)"
    >
      <app-icon
        *ngIf="i === selectedIndex"
        [icon]="optionIcon.icon"
        [size]="optionIcon.size"
        [colour]="optionIcon.colour"
        [margin]="{ right: optionIcon.margin }"
      ></app-icon>
      <div [style.marginLeft.px]="i === selectedIndex ? 0 : optionIcon.size + optionIcon.margin">
        {{ option.string ?? (option.stringId | translateString : lang) }}
      </div>
    </div>
  </div>
</div>
